import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../assets/icons/pdficon.svg'


const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = { class: "header !tw-ml-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Edit Certification", -1)
const _hoisted_4 = { class: "modal_form" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "cerificate__content !tw-border-none"
}
const _hoisted_7 = { class: "left_block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", null, "Attachment", -1)
const _hoisted_9 = { class: "left_block__content" }
const _hoisted_10 = {
  key: 0,
  class: "left_block__content__item"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "right_block" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h5", null, "Members", -1)
const _hoisted_15 = { class: "right_block__content" }
const _hoisted_16 = { class: "members__list" }
const _hoisted_17 = { class: "members__list__status" }
const _hoisted_18 = { class: "member_img" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "tw-w-full tw-flex tw-gap-3 tw-items-center tw-justify-end tw-pt-4 tw-border-t-dashed-custom" }
const _hoisted_21 = { class: "loader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    className: ['edit_certificate_modal'],
    width: "835px",
    height: "auto"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            onClick: $setup.onClickCloseButton,
            variant: "text"
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          ($setup.certificateData)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString($setup.certificateData.name), 1))
            : _createCommentVNode("", true),
          (!$setup.loader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    ($setup.attachmentData)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _hoisted_11,
                          ($setup.attachmentData[0])
                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString($setup.attachmentData[0].originalName || "Upload"), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_v_text_field, {
                      placeholder: "Search",
                      class: "search_field",
                      "bg-color": "#fff",
                      "prepend-inner-icon": "mdi-magnify",
                      variant: "outlined",
                      modelValue: $setup.searchMembers,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchMembers) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("ul", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredMembers, (data) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: data.toUser.id
                          }, [
                            _createVNode(_component_v_checkbox, {
                              color: "indigo",
                              modelValue: $setup.checkedMembers,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.checkedMembers) = $event)),
                              value: data?.toUser?.id
                            }, null, 8, ["modelValue", "value"]),
                            _createElementVNode("div", _hoisted_18, [
                              (data.toUser?.profileURL)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: data.toUser?.profileURL
                                  }, null, 8, _hoisted_19))
                                : (_openBlock(), _createBlock(_component_UserProfileLogo, {
                                    key: 1,
                                    userName: `${data?.toUser?.firstName} ${data?.toUser?.lastName}`
                                  }, null, 8, ["userName"]))
                            ]),
                            _createElementVNode("p", null, _toDisplayString(data.toUser.firstName) + " " + _toDisplayString(data.toUser.lastName), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Button, {
              variant: "secondary",
              label: "Cancel",
              isCapitalize: true,
              onClick: $setup.onClickCloseButton,
              class: "!tw-w-auto"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              variant: "accent",
              label: "SAVE",
              isCapitalize: true,
              onClick: $setup.updateMembers,
              isLoading: $setup.loader,
              disabled: $setup.loader,
              class: "!tw-w-auto"
            }, null, 8, ["onClick", "isLoading", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          ($setup.loader)
            ? (_openBlock(), _createBlock(_component_CommonLoader, {
                key: 0,
                loading: $setup.loader
              }, null, 8, ["loading"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}